import { useMutation, useQuery } from '@tanstack/react-query'
import { store } from '../..'
import { queryClient } from '../../..'
import { setAlert, setIsLoading } from '../../components/components-slice'
import moment from 'moment'
import { employeeTrainings } from '../../../api/employees/training'

export function useGetTrainingSummary() {
  return useQuery(['training-summary'], () => {
    return employeeTrainings.getTrainingSummary()
  })
}
export function useGetemployeeTrainings(limit, page, search) {
  return useQuery(
    ['employee-training', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return employeeTrainings.getEmployeeTrainings({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        data.data.forEach((training) => {
          training.passing_criteria = `${training?.passing_grade} / ${training?.questions?.length}`
          training.created = moment(training.created).format('MMMM D, YYYY')
          training.period = `${moment(training.created).format(
            'MMMM D, YYYY'
          )} to ${moment(training.deadline).format('MMMM D, YYYY')}`
          training.computedActions = [0]
        })

        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useGetCompletedTrainings(limit, page, search) {
  return useQuery(
    ['completed-training', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return employeeTrainings.getCompletedTrainings({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        data.data.forEach((training) => {
          training.created = moment(training.created).format('MMMM D, YYYY')
          training.passing_grade_percentage = `${(
            (parseInt(training.passing_grade) / training.questions?.length) *
            100
          ).toFixed(0)}%`
          training.score = `${(
            (parseInt(training.assignments[0]?.grade) /
              parseInt(training.passing_grade)) *
            100
          ).toFixed(0)}%`
          training.period = `${moment(training.created).format(
            'MMMM D, YYYY'
          )} to ${moment(training.deadline).format('MMMM D, YYYY')}`
        })

        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useUploadTrainingCertificate() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employeeTrainings.uploadTrainingCertificate(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('employee-trainings')
        store.dispatch(
          setAlert(
            true,
            'success',
            'Training certificate uploaded successfully'
          )
        )
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useSubmitTrainingResult() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employeeTrainings.submitTrainingResult(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('training_result')
        store.dispatch(
          setAlert(true, 'success', 'Training completed successfully')
        )
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useCommentOnTraining() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employeeTrainings.commentOnTraining(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('employee-trainings')
        store.dispatch(
          setAlert(true, 'success', 'Training comment added successfully')
        )
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}
